import React, { useEffect, useState } from "react";
import { getLeaderBoard } from "../../api/user";
import PageContainer from "../pages/PageContainer";
import { useNavigate } from "react-router-dom";
import Loader from "../Loader";
import GreenTick from "../../images/green-tick.png";
import GameSideBar from "../Games/GameSideBar";
import Flag from 'react-world-flags';
import { COUNTRIES } from "../../icons/countryFlag";

const LeaderboardSecton = (props) => {
  const game_id = props.gameId ?? null;
  const slug = props.slug ?? null;
  const private_portfolio = props.private_portfolio ?? false;
  const [leaderBoardData, setLeaderBoardData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [isDataFeteched, setisDataFeteched] = useState(false);
  const [apiCall, setApiCall] = useState(false);
  const isMobileView = document.body.clientWidth <= 768;

  const navigate = useNavigate();
  const [scrollPosition, setScrollPosition] = useState(0);

  const fetchLeaderBoard = async () => {
    try {
      if (!apiCall) {
        const response = await getLeaderBoard(game_id);
        if (response?.data?.status === 200) {
          setApiCall();
          setApiCall(true);
          setTimeout(() => {
            setApiCall(false);
          }, 2000);
          const LeaderBoardData = response.data.data.data;
          setLeaderBoardData(LeaderBoardData);
          setLoading(false);
          setisDataFeteched(true);

          const toggle = localStorage.getItem("toggle") === "true";

          if (toggle) {
            console.log("Scrolling to a specific section because toggle is ON.");
            // alert('scrolling started');
            // Reset the toggle value to prevent scrolling on subsequent visits
            localStorage.setItem("toggle", "false");
            clearScrollPosition();
          } else {
            console.log("No scroll because toggle is OFF.");
          }


        } else {
          setLoading(false);
        }
      }
    } catch (error) {
      setLoading(false);
      console.error("Error:", error);
    }
  };
  useEffect(() => {
    if (!isDataFeteched) fetchLeaderBoard();
  }, [isDataFeteched]);

  const handleLoadMore = () => {
    setItemsPerPage(itemsPerPage + 10);
  };

  // Handle scroll position saving
  const handleScroll = () => {
    setScrollPosition(window.scrollY);
  };

  const scrollPositionKey = "leaderBoradPageScroll";

  const initScrollPosition = () => {
    localStorage.setItem(
      scrollPositionKey,
      JSON.stringify({
        scrollPosition,
        itemsPerPage,
      })
    );
  };

  const clearScrollPosition = () => {
    const leaderBoradPage = localStorage.getItem(scrollPositionKey)
      ? JSON.parse(localStorage.getItem(scrollPositionKey))
      : null;

    if (leaderBoradPage) {
      setItemsPerPage(leaderBoradPage.itemsPerPage);
      setTimeout(() => {
        window.scrollTo(0, leaderBoradPage.scrollPosition);
      }, 100);

      localStorage.removeItem(scrollPositionKey);
    }
  };

  // Handle scroll position saving
  const navigateToUserProfile = (event, userId) => {
    event.preventDefault();
    if (!private_portfolio) {
      initScrollPosition();
      if(game_id){
        navigate(
          `/${slug}/profile/${userId}`,
          {
            state: { game_id: game_id, slug: slug },
          }
        );
      }else{
        navigate(
          `/profile/${userId}`,
          {
            state: { game_id: game_id, slug: slug },
          }
        );
      }
    }
  };

  // Restore scroll position when component mounts
  useEffect(() => {
    // Add event listener for scroll
    window.addEventListener("scroll", handleScroll);

    // Cleanup event listener
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [scrollPosition]);

  return (
    <PageContainer gamePage={game_id && true}>
      {game_id && <GameSideBar activeMenu="leaderboard" slug={slug} />}
      <div>
        {isMobileView ? (
          <div className="mobile-view-content mb-20">
            {loading ? (
              <Loader dark />
            ) : leaderBoardData.length === 0 ? (
              <div className="text-center text-gray-500 text-lg mt-10">
                No one is in the leaderboard now.
              </div>
            ) : (
              leaderBoardData.slice(0, itemsPerPage).map((user, index) => (
                <a
                  href="#"
                  onClick={($event) =>
                    navigateToUserProfile($event, user.id)
                  }
                >

                  <div
                    key={index}
                    className="mt-8 flex  flex-wrap flex-col border-b border-gray-300"
                  >
                    <div key={index} className="flex">
                      <div className="flex items-center gap-y-6">
                        <span className="mt-1.5  text-md mr-1 text-primaryColor font-bold">
                          {index + 1}
                        </span>
                      </div>
                      <div>

                        <img
                          src={user.image}
                          alt="imgwrapper"
                          className="ml-2 object-cover w-10 h-10 rounded-full mt-1"
                        />

                      </div>

                      <div className="text-sm space-y-5 mt-0.5 flex items-center">
                        <p className="space-x-2 flex items-center">
                          {/* <Link to={`/profile/${user.id}`}>
                          <span className="text-xs font-bold">
                            {user.user_name}
                          </span>
                        </Link> */}

                          {/* <span className="ml-2 text-gray-500  text-[18px]">
                            @{user.user_name}
                            {
                              COUNTRIES.filter(item => item.iso2 === user.code).length > 0
                              ? COUNTRIES.filter(item => item.iso2 === user.code).map(item => (
                                  <span className="inline ml-2" style={{ width: 24, height: "auto" }} key={item.iso2}>{item.flag}</span>
                                ))
                              : <Flag code={user.code} style={{ width: 23, height: "auto" }} className="inline ml-2" />
                            }

                          </span> */}
                          <span className="ml-2 text-gray-500 text-[18px]">
  @{user.user_name}
  {
    COUNTRIES.some(item => item.iso2 === user.code)
      ? COUNTRIES.filter(item => item.iso2 === user.code).map(item => (
          <img
            key={item.iso2}
            src={item.flag}
            alt={item.name}
            width="24"
            height="16"
            className="inline ml-2"
          />
        ))
      : <Flag code={user.code} style={{ width: 23, height: "auto" }} className="inline ml-2" />
  }
</span>
                          {user.green_tick ? (
                            <img
                              className="px-1 object-cover"
                              src={GreenTick}
                              alt="Green Tick"
                            />
                          ) : null}
                        </p>
                      </div>
                    </div>
                    <div className="ml-[89px] space-x-2 flex flex-wrap mb-3 text-sm md:text-base mt-4  md:flex lg:justify-between font-bold  lg:ml-48 md:mb-5">
                      <div className="flex items-center">
                        <p
                          className={`text-[16px]  ${user.performance >= 0
                            ? "text-greenXD"
                            : "text-red-700"
                            }`}
                        >
                          {user.performance}%+
                        </p>
                        <p className="text-gray-500 ml-2 font-[12px] font-bold">
                          Performance
                        </p>
                      </div>
                      <p className="border-r border-gray-500 "></p>
                      <p className="text-gray-600 text-[16px]">
                        {user.follower_count}{" "}
                        <span className="text-gray-500 text-[12px] font-bold">
                          Followers
                        </span>
                      </p>
                      <p className="text-gray-500"></p>
                    </div>
                  </div>
                </a>
              ))
            )}
            <div>
              {leaderBoardData.length > itemsPerPage && (
                <div className="text-center">
                  <button
                    className="py-2 px-4 w-auto mt-2 mb-10 text-greenXD justify-end"
                    onClick={handleLoadMore}
                  >
                    Load More
                  </button>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="web-view-content bg-white mt-8">
            {loading ? (
              <Loader dark />
            ) : leaderBoardData.length === 0 ? (
              <div className="text-center text-gray-500 text-lg mt-10">
                No one is in the leaderboard now.
              </div>
            ) : (
              leaderBoardData.slice(0, itemsPerPage).map((user, index) => (


                <div
                  key={index}
                  className="py-7 md:block bg-white max-w-[60rem] mx-auto hover:bg-gray-50 border-b border-gray-300"
                >

                  <a
                    href="#"
                    onClick={($event) =>
                      navigateToUserProfile($event, user.id)
                    }
                    className="leaderboard-profile"
                  >
                    <div
                      key={index}
                      className="flex  flex-wrap ml-8"
                    >
                      <div className=" flex items-center lg:w-2/5 w-full gap-4">
                        <div className="flex items-center gap-y-6">
                          <span className="mt-1.5 text-xl text-GothamRounded mr-1 text-primaryColor font-bold">
                            {index + 1}
                          </span>
                        </div>
                        <div className="w-10">

                          <img
                            src={user.image}
                            alt="imgwrapper"
                            className="object-cover w-10 h-10 rounded-full mt-1"
                          />

                        </div>

                        <div className="text-md space-y-5 mt-0.5 w-3/4">
                          <p className="space-x-2">
                            {/* <Link to={`/profile/${user.id}`}>
                            <span className="font-bold">{user.user_name}</span>
                          </Link> */}
                          <span className="ml-2 text-gray-500 text-[18px]">
  @{user.user_name}
  {
    COUNTRIES.some(item => item.iso2 === user.code)
      ? COUNTRIES.filter(item => item.iso2 === user.code).map(item => (
          <img
            key={item.iso2}
            src={item.flag}
            alt={item.name}
            width="24"
            height="16"
            className="inline ml-2"
          />
        ))
      : <Flag code={user.code} style={{ width: 23, height: "auto" }} className="inline ml-2" />
  }
</span>

                            {user.green_tick ? (
                              <img
                                className="px-1 object-cover"
                                src={GreenTick}
                                alt="Green Tick"
                              />
                            ) : null}
                          </p>
                        </div>
                      </div>
                      <div className="pl-5 lg:w-3/5 w-full space-x-2 flex flex-wrap mb-3 text-sm md:text-base mt-4  md:flex font-bold md:mb-5">
                        <div className="flex items-center">
                          <p
                            className={`text-[16px] ${user.performance >= 0
                              ? "text-greenXD"
                              : "text-red-700"
                              }`}
                          >
                            {user.performance}%+
                          </p>
                          <p className="text-gray-500 ml-2 text-[12px] font-bold">
                            Performance
                          </p>
                        </div>
                        <p className="border-r border-gray-500 "></p>
                        <p className="text-gray-600 text-[16px] font-bold">
                          {user.follower_count}{" "}
                          <span className="text-gray-500 text-[12px]">
                            Followers
                          </span>
                        </p>
                        <p className="text-gray-500"></p>
                      </div>
                    </div>
                  </a>
                </div>
              ))
            )}
            <div>
              {leaderBoardData.length > itemsPerPage && (
                <div className="text-center">
                  <button
                    className="py-2 px-4 w-auto mt-2 mr-16 text-lg font-bold text-greenXD justify-end"
                    onClick={handleLoadMore}
                  >
                    More
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </PageContainer>
  );
};

export default LeaderboardSecton;
